import { BrowserRouter as Router, Route, Switch } from "react-router-dom"

// STYLES
import './styles/blog.css'
import './styles/error-404.css'
import './styles/my-web-styles.css'

// SECTIONS PERMANENTS
import Header from './molecules/Header.jsx'
import Footer from './molecules/Footer.jsx'

// PAGES 
import PageMaster from './pages/PageMaster.jsx'
import PageContact from './pages/PageContact.jsx'
import PageLastProjects from './pages/PageLastProjects.jsx'
import PageBlog from './pages/PageBlog.jsx'
import PageInputBlog from './pages/PageInputBlog.jsx'

// ERRORS 404
import ErrorGeneral from './pages/errors 404/ErrorGeneral.jsx'
import ErrorSystem from './pages/errors 404/ErrorSystem.jsx'

// TESTING
import SectionLoadingLoader from './organisms/SectionLoadingLoader.jsx'
import ButtonHeader from "./molecules/ButtonHeader"

const App = () => (
<Router>

  < Header />
  
  <Switch>
    
    {/* PAGES */}
    <Route path="/" exact component={ PageMaster } />
    <Route path="/contacto" component={ PageContact } />
    <Route path="/ultimos-proyectos" component={ PageLastProjects } />
    <Route path="/blog/post/:url" component={ PageInputBlog } />
    <Route path="/blog" component={ PageBlog } />

    {/* TESTING */}
    {/* <Route path="/odio-a-los-cms" component={ PageInputBlog } /> */}
    <Route path="/loader" component={ SectionLoadingLoader } />

    {/* PAGES NOT FOUNT - ERROR 404 */}
    <Route path="/system" component={ ErrorSystem } />
    <Route component={ ErrorGeneral } />
  
  </Switch>

  < ButtonHeader />
  < Footer />

</Router>
)

export default App;
